import React, { useState } from 'react';

import SocialsGroup from './socialsGroup'
import PrivacyModal from './privacyModal';

const Footer = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <footer className="py-2 bg-gray-800 relative">
      <nav className="max-w-md p-4 mx-auto text-sm md:p-4">
        <SocialsGroup />
        <p className="text-white opacity-60 text-center mt-4">
          Jason Cho
          <span className="text-teal-300 pl-2">&#169;2026</span>
          <span className='px-3'>|</span>
          <button
            onClick={() => setIsOpen(true)}
            className="text-sm text-gray-300 hover:text-white"
          >
            Privacy Policy
          </button>
        </p>
      </nav>

      <PrivacyModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </footer>
  );
};

export default Footer;
